import { CheckCircleOutlined, CloseCircleOutlined, TeamOutlined } from '@ant-design/icons';
import cn from 'classnames';

import styles from './UsersAssignmentPage.module.scss';

export const ANNOTATION_ITEMS = [
  {
    id: 1,
    icon: <CheckCircleOutlined className={cn(styles['annotation-icon'], styles['annotation-icon-success'])} />,
    title: 'С галочкой (Основной список)',
    description:
      'Получат уведомление об успешном прохождении тестирования. Статус изменится на "Ожидание документов". Позже вы сможете провести модерацию (одобрить/отклонить).',
  },
  {
    id: 2,
    icon: <TeamOutlined className={cn(styles['annotation-icon'], styles['annotation-icon-reserve'])} />,
    title: 'Без галочки (Резерв)',
    description:
      'Получат уведомление "Вы в резерве". Статус изменится на "Резерв". Модерация для них недоступна, но позже их можно активировать.',
  },
  {
    id: 3,
    icon: <CloseCircleOutlined className={cn(styles['annotation-icon'], styles['annotation-icon-failed'])} />,
    title: 'Тест не сдан',
    description:
      'Автоматически получат уведомление о неуспешном прохождении тестирования. Не требуют распределения - обрабатываются автоматически.',
  },
];
